import instance from "./instance";
import logger from "../sentryLogger";
import {station as urls} from "./urls";

export function updateStationStatus(isActive: boolean): Promise<void> {
    return instance
        .request({
            url: urls.updateStationStatus,
            method: "POST",
            data: {
                isActive,
            },
        })
        .then((response) => response.data)
        .catch(() => {
            logger.warn("Failed to update station activity status.");
        });
}
